import { API_URL, tenantConfig } from 'config';
import AuthService from 'services/AuthService';
import { HttpService } from 'services/HttpService';

export interface NetSuiteResponse<TItem> {
  links: Link[];
  hasMore: boolean;
  count: number;
  offset: number;
  totalResults: number;
  items: TItem[];
}

export interface Link {
  rel: string;
  href: string;
}

export type OverdueBalanceItem = {
  programId: string;
  overdueBalance: number;
  daysOverdueOldest: number;
};

export async function overdueBalance(): Promise<NetSuiteResponse<OverdueBalanceItem>> {
  const url = `${API_URL}/profiles/overdueBalance`;
  const headers = {
    TenantId: tenantConfig.id,
    Authorization: AuthService.getBearerToken(),
  };

  return await HttpService.get(url, { headers }).toPromise();
}

export async function GetUserVerified(nccerNumber: string): Promise<any> {
  const url = `${API_URL}/profiles/verification/${nccerNumber}`;
  const headers = {
    TenantId: tenantConfig.id,
    Authorization: AuthService.getBearerToken(),
  };

  const response = await HttpService.get(url, { headers }).toPromise();
  //Returning User Attributes as that has information like phone number and phone number verified
  return JSON.parse(response).userAttributes
}

export async function sendVerificationCode(nccerNumber: string, phone: string, messageType: string): Promise<any> {
  const url = `${API_URL}/profiles/verification/send`;
  const headers = {
    TenantId: tenantConfig.id,
    Authorization: AuthService.getBearerToken(),
  };
  const data = {
    cardNumber: nccerNumber,
    phone: phone,
    messageType: messageType
  }

  //return status as success or fail
  return await HttpService.post(url, { headers, data }).toPromise();
}

export async function sendEmailVerificationCode(nccerNumber: string, email: string, messageType: string): Promise<any> {
  const url = `${API_URL}/profiles/verification/send`;
  const headers = {
    TenantId: tenantConfig.id,
    Authorization: AuthService.getBearerToken(),
  };
  const data = {
    cardNumber: nccerNumber,
    email: email,
    messageType: messageType
  }

  //return status as success or fail
  return await HttpService.post(url, { headers, data }).toPromise();
}

export async function validatePhoneCode(nccerNumber: string, phoneNumber: string, code: string): Promise<any> {
  const url = `${API_URL}/profiles/verification/validate/phone`;
  const headers = {
    TenantId: tenantConfig.id,
    Authorization: AuthService.getBearerToken(),
  };

  const data = {
    cardNumber: nccerNumber,
    phoneNumber: phoneNumber,
    code: code
  }
  //return status as success or fail
  return await HttpService.post(url, { headers, data}).toPromise();
}

export async function validateEmailCode(nccerNumber: string, email: string, code: string): Promise<any> {
  const url = `${API_URL}/profiles/verification/validate/email`;
  const headers = {
    TenantId: tenantConfig.id,
    Authorization: AuthService.getBearerToken(),
  };

  const data = {
    cardNumber: nccerNumber,
    email: email,
    code: code
  }
  //return status as success or fail
  return await HttpService.post(url, { headers, data}).toPromise();
}

export async function externalAccountOptIn(nccerNumber: string, digitalWalletCardStatus: boolean): Promise<any> {
  const url = `${API_URL}/profiles/externalAccountOptIn`;
  const headers = {
    TenantId: tenantConfig.id,
    Authorization: AuthService.getBearerToken(),
  };

  const data = {
    nccerNumber: nccerNumber,
    digitalWalletCardStatus: digitalWalletCardStatus
  }
  //return status as success or fail
  return await HttpService.post(url, { headers, data}).toPromise();
}
